import { Icon } from '@mgmresorts/mgm-ui';
import React from 'react';

import { useContent } from '../../../hooks/useContent';
import { Container } from '../Container';

import { StyledSuccessInfo } from './styles';

export function WelcomeMGMRewards() {
  const { getContentByPath } = useContent();
  return (
    <Container height='auto'>
      <Icon name='party-popper' variant='filled' size='large' />
      <StyledSuccessInfo variant='body-regular-m' as='p' className='identity__welcome-page-info'>
        {getContentByPath('accountCreation.welcomeMgmPageInfo')}
      </StyledSuccessInfo>
    </Container>
  );
}
